// ════════════════════════════════════════════════════════════════════════════
//  transferenciasService.ts  —  Transferências entre caixas
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type { RealizarTransferenciaRequest, TransferenciaResultado } from '../types';
import type { CaixaLancamento } from '@/features/caixa/types';

export const transferenciasService = {
  async realizar(req: RealizarTransferenciaRequest): Promise<TransferenciaResultado> {
    const { data } = await apiClient.post<TransferenciaResultado>('/api/caixa/transferencia', req);
    return data;
  },

  async listar(dtInicio?: string, dtFim?: string): Promise<CaixaLancamento[]> {
    const { data } = await apiClient.get<CaixaLancamento[]>('/api/caixa/transferencias', {
      params: { dtInicio, dtFim },
    });
    return data;
  },
};
